export enum groupAccessTypes {
  OPEN = 'open',
  CLOSED = 'closed',
  APPLICATION = 'application'
}
